const makeBadge = ({ badgeVariant, discountAmount, text }) => {
  const defaultBadgeProps = {
    value: text,
    customProps: {
      color: 'primary',
      className: 'cgt-effect-form-border-hovered',
    },
  }

  const variants = {
    ukraineDonation: {
      ...defaultBadgeProps,
      value: `${discountAmount}% to Ukraine`,
      customProps: {
        color: 'primary',
        className: 'ukranian-badge__donation cgt-effect-form-border-hovered',
      },
    },
    ukraineBadge: {
      ...defaultBadgeProps,
      value: ' ',
      customProps: {
        color: 'primary',
        className: 'ukranian-badge cgt-effect-form-border-hovered',
      },
    },
  }

  return variants[badgeVariant] || defaultBadgeProps
}

export default makeBadge
